<template>
    <div class="main_r_info_box">
        <ul v-if="articleList.length > 0" class="main_r_info_box_ul">
            <li v-for="(item,i) in articleList" :key="i">
                <a :href="item.contentIsChain == '1' ? item.contentChain : '/detail?docId='+item.id" :title="item.contentTitle" target="_blank" style="display:block;">
                    <div class="main_r_info_box_li_imgbox">
                        <img class="main_img" src="../../assets/imgs/map.png" alt="">
                        <img style="border-top: 2px solid rgb(27, 153, 198);margin-top: 4px;padding-top: 4px;" class="main_img" src="../../assets/imgs/map2.png" alt="">
                    </div>
                    <p class="main_r_info_box_li_p" v-html="item.contentDetails ? item.contentDetails : ''"></p>
                </a>
            </li>
        </ul>
        <!-- <div v-if="articleList.length > 0" class="page_box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNum"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div> -->
        <el-empty v-if="articleList.length <= 0" description="暂无数据!"></el-empty>
    </div>
</template>

<script>

import $ from 'jquery';
import api from "@/../static/api/api.js";

import defaultImg1 from '@/assets/imgs/default.png'
import defaultImg2 from '@/assets/imgs/default2.png'
import defaultImg3 from '@/assets/imgs/default3.png'

export default {
    name: 'imglist',
    props:['currentId'],
    data() {
        return {
            imgBase: this.$store.state.imgBase,
            defaultImg1: defaultImg1,//轮播图默认图片
            defaultImg2: defaultImg2,//研究项目默认图
            defaultImg3: defaultImg3,//交流传播默认图
            articleList: [],//右侧展示文章列表数据
            pageNum: 1,//分页的三个值
            pageSize: 4,
            total: 0,
            curtitle: ''
        }
    },
    watch: {
        currentId (val) {
            this.rightInfoFn(val);
        }
    },
    mounted() {
        this.rightInfoFn(this.currentId);//默认展示CIKD大讲堂
        
    },
    methods: {
        //加载右侧文章列表数据
        rightInfoFn(index, curNum=1){
            let _this = this;
            let menuId = index;
            let pageNum = curNum;
            let pageSize = 4;
            api.getArticleList(menuId, pageNum, pageSize).then(res => {
                if (res.data) {
                    _this.articleList = res.data.list;
                    _this.pageNum = res.data.pageNum;
                    _this.pageSize =res.data.pageSize;
                    _this.total =res.data.total;
                    console.log(res.data.list,'res.data.list');
                    _this.$emit('titleInfo',res.data.categoryPosition);//将当前所属栏目传给父组件
                    _this.curtitle = res.data.title;
                    setTimeout(()=>{
                        $('.main_r_info_box_li_p p').css('margin-bottom','18px');
                    },20)
                    
                }
            });
        },
        //分页操作函数1
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        //分页操作函数2
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.rightInfoFn(this.currentId, val);
        }
    }
}
</script>

<style scoped>

.main_r_info_box{
    width:100%;
    margin-top:38px;
}
.main_r_info_box_ul{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.main_r_info_box_ul li{
    width: 99%;
    height:610px;
    overflow: hidden;
    float: left;
    margin-bottom: 31px;
    background: #fff;
    border: 1px solid #D9D9D9;
}
.main_r_info_box_ul li:hover{
    box-shadow: 0px 5px 5px 0px rgba(223, 226, 230, 0.75);
}

.main_r_info_box_li_imgbox{
    width: 480px;
    height:610px;
    overflow: hidden;
    position: relative;
    float:left;
}
.main_r_info_box_li_imgbox .main_img{
    width:100%;
    display: block;
}
.main_r_info_box_li_p{
    width: 284px;
    height: 141px;
    font-size: 15px;
    /* font-family: STXihei; */
    font-weight: bold;
    color: #4D4D4D;
    line-height: 21px;
    float:left;
    margin-left: 46px;
    margin-top: 33px;
    text-align: left;
}
.main_r_info_box_li_p p{
    margin-bottom:33px;
}

.main_r_info_box_li_h4{
    width: 284px;
    height: 16px;
    font-size: 16px;
    /* font-family: STXihei; */
    font-weight: bold;
    color: #333333;
    line-height: 16px;
    float: left;
    margin-left: 46px;
    margin-top: 57px;
    text-align: left;
}

/* 分页 */
.page_box{
    width:100%;
    height:63px;
    margin-top:30px;
    margin-bottom:100px;
}





</style>
